import { DesignSystem } from '@/src/design-system'

export function MesaCardSkeleton() {
  return (
    <DesignSystem.Skeleton.Skeleton
      style={{
        width: '100%',
        borderRadius: 16,
        height: 113,
        overflow: 'hidden',
      }}
    />
  )
}
